define("settings/components/subscription-help-list-item", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li>
    <div class="tAC--accordion__title" {{on "click" this.toggleIsActive}}>
      {{@title}}
      <span class="tAC--accordion__icon u--fadeIn {{if this.isActive 'is--active'}}">
        {{svg-jar "nav-down" class="o--icon--md o--icon--light"}}
      </span>
    </div>
    {{#if this.isActive}}
      <p class="tAC--accordion__details u--fadeIn">
        {{@details}}
      </p>
    {{/if}}
    <hr />
  </li>
  */
  {
    "id": "kVMb0qQ2",
    "block": "[[[10,\"li\"],[12],[1,\"\\n  \"],[11,0],[24,0,\"tAC--accordion__title\"],[4,[38,0],[\"click\",[30,0,[\"toggleIsActive\"]]],null],[12],[1,\"\\n    \"],[1,[30,1]],[1,\"\\n    \"],[10,1],[15,0,[29,[\"tAC--accordion__icon u--fadeIn \",[52,[30,0,[\"isActive\"]],\"is--active\"]]]],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"nav-down\"],[[\"class\"],[\"o--icon--md o--icon--light\"]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[30,0,[\"isActive\"]],[[[1,\"    \"],[10,2],[14,0,\"tAC--accordion__details u--fadeIn\"],[12],[1,\"\\n      \"],[1,[30,2]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,\"hr\"],[12],[13],[1,\"\\n\"],[13]],[\"@title\",\"@details\"],false,[\"on\",\"if\",\"svg-jar\"]]",
    "moduleName": "settings/components/subscription-help-list-item.hbs",
    "isStrictMode": false
  });
  let SubscriptionHelpListItemComponent = _exports.default = (_class = class SubscriptionHelpListItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "isActive", _descriptor, this);
    }
    toggleIsActive() {
      this.isActive = !this.isActive;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isActive", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleIsActive", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleIsActive"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SubscriptionHelpListItemComponent);
});